import React from "react";
import { View, Text, StyleSheet, Image } from "react-native-web";
import logo from "../logo.png";

const Footer = (props) => (
	<View style={styles.container}>
		<View
			style={{
				flexDirection: "row",
				marginRight: 20,
				alignItems: "center",
				justifyContent: "flex-end",
			}}
		>
			{props.currentSurvey && props.currentSurvey.users
				? Object.values(props.currentSurvey.users)
						.slice(0, 5)
						.map((item) => (
							<Image
								style={{
									marginLeft: -10,
									width: 25,
									height: 25,
									borderRadius: 15,
									zIndex: 9999,
									borderWidth: 2,
									borderColor: "white",
								}}
								source={{ uri: item.userpicture }}
							/>
						))
				: null}
			{props.currentSurvey && props.currentSurvey.users && (
				<Text
					style={{
						marginLeft: 5,
					}}
				>
					{Object.values(props.currentSurvey.users).length}
					{" Responses so far"}
				</Text>
			)}

			{props.totalVotes && (
				<Text
					style={{
						marginLeft: 5,
					}}
				>
					{props.totalVotes}
					{" Votes"}
				</Text>
			)}
		</View>
	</View>
);

const styles = StyleSheet.create({
	container: {
		position: "fixed",
		left: 0,
		bottom: 0,
		width: "100%",
		height: 50,
		backgroundColor: "#F7FAFD",
		color: "white",
		textAlign: "center",
		borderTopWidth: 1,
		borderColor: "#E2E8EF",
		justifyContent: "center",
	},
	text: {
		fontSize: 10,
		fontFamily: "NunitoSans",
		color: "white",
		letterSpacing: 2,
		textAlignVertical: "bottom",
		marginTop: 5,
	},
});

export default Footer;
